// extracted by mini-css-extract-plugin
export default {"root":"TopModal_root__fxeIE","close":"TopModal_close__lGW27"};